﻿import {Core} from "./Core";
import {PlayerData} from "../Data/PlayerData";
import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";
import {TypesSocial} from "@dp-instant/interfaces";
import {di} from "@dp-instant/core";

const STORAGE_KEY = "homo-evolution-player-data";

// let canSaveLocal = true;
// let saveLocalDelay = 5000;

export class AuthManager extends MonoBehaviour {
    resetRequested = false;

    #cookie = di.get(TypesSocial.cookie);

    Authenticate() {
        this.emit("AuthComplete", true);
    }

    async SaveLocal() {
        if (this.resetRequested) return;
        try {
            let data = Core.Player.toJSON();
            await this.#cookie.save(STORAGE_KEY, data);
            //await this.#cookie.write(STORAGE_KEY);
            // await FBInstant.player.setDataAsync({
            //     [STORAGE_KEY]: data,
            // });
        } catch (e) {
            console.log("SAVE ERROR", e);
        }
    }

    async LoadLocal() {
        try {
            // let data = await FBInstant.player.getDataAsync([STORAGE_KEY]);
            let data = await this.#cookie.get([STORAGE_KEY]);
            data =
                data[STORAGE_KEY] && data[STORAGE_KEY].PlanetsSave.TutorSave.bubbles
                    ? data[STORAGE_KEY]
                    : null;
            if (data) {
                Core.Player.CopyPlayerFrom(data);
                if (data.GlobalVersion < PlayerData.GLOBAL_VERSION_VALUE) {
                    Core.Player.DefaultStart();
                }
            } else {
                Core.Player.DefaultStart();
            }
        } catch (e) {
            console.log("LOAD ERROR", e);
        }
    }

    async Reset() {
        this.resetRequested = true;
        await this.#cookie.erase(STORAGE_KEY);
        // await FBInstant.player.setDataAsync({
        //     [STORAGE_KEY]: null
        // });
    }
}
